import { ToolLogo } from "@/components/Common/ToolLogo/ToolLogo";
// import { UserBalance } from "@/components/Common/UserBalance/UserBalance";
import { useMainStore } from "@/store/main";
import { SmartLink } from "../Common/SmartLink/SmartLink";
import { Tool } from "@/types";
import { useUserStore } from "@/store/user";
// import { BalanceType } from "@/types/user";

type IoElementsListType = {
  height?: string;
  padding?: string;
  classColumn2?: string;
  onClick?: (item: Tool) => void;
  /** When set, tool cards link to these absolute URLs (e.g. `APP_DOMAIN` from another host). */
  resolveHref?: (item: Tool) => string;
};

export const IoElementsList = ({ onClick, resolveHref }: IoElementsListType) => {
  const getToolOptions = useMainStore((state) => state.getToolOptions);
  const theme = useUserStore((state) => state.theme);

  return getToolOptions().map((item) => {
    const { value, href } = item;
    const linkHref = resolveHref ? resolveHref(item) : href;

    return (
      <SmartLink
        data-testid={`MainLogo_${value}Link`}
        key={href}
        href={linkHref}
        onClick={onClick ? () => onClick(item) : undefined}
      >
        <div
          style={{
            backgroundImage:
              theme === "dark"
                ? `url(${item.bg})`
                : `url(${item.bg?.replace(".png", "-light.png")})`,
            ...(theme === "dark"
              ? {
                backgroundSize: "101% 101%"
              }
              : {
                backgroundSize: "50% 100%",
                backgroundPosition: "right center"
              })
          }}
          className={`item relative flex h-20 cursor-pointer flex-col items-stretch justify-between rounded-[8px] border border-gray-dark-200 bg-white bg-cover bg-bottom bg-no-repeat
             p-2 transition-colors hover:border-gray-dark-1200 dark:bg-gray-dark-200 dark:bg-gray-dark-600 md:h-[120px] md:p-4
            `}
        >
          <ToolLogo tool={item} />
        </div>
      </SmartLink>
    );
  });
};
